const beFieldNames = Object.freeze({
  patientId: "patientId",
  patientFirstName: "patientFirstName",
  patientMiddleName: "patientMiddleName",
  patientLastName: "patientLastName",
  patientDob: "patientDob",
  patientGender: "patientGender",
  patientLanguage: "patientLanguage",
  patientAddress: "patientAddress",
  patientCity: "patientCity",
  patientState: "patientState",
  patientZip: "patientZip",
  patientEmail: "patientEmail",
  patientPhone: "patientPhone",
  patientPhoneType: "patientPhoneType",

  patientCaregiverName: "patientCaregiverName",
  patientCaregiverLastName: "patientCaregiverLastName",
  patientCaregiverEmail: "patientCaregiverEmail",
  patientCaregiverPhone: "patientCaregiverPhone",
  patientCaregiverPhoneType: "patientCaregiverPhoneType",

  patientCoveragePrimaryType: "patientCoveragePrimaryType",
  patientCoveragePrimaryGroupId: "patientCoveragePrimaryGroupId",
  patientCoveragePrimaryMemberId: "patientCoveragePrimaryMemberId",
  patientCoveragePrimaryName: "patientCoveragePrimaryName",
  patientCoveragePrimaryPhone: "patientCoveragePrimaryPhone",
  patientCoveragePrimaryCategoryType: "patientCoveragePrimaryCategoryType",
  patientCoveragePrimaryActiveDate: "patientCoveragePrimaryActiveDate",
  patientCoveragePrimaryExpirationDate: "patientCoveragePrimaryExpirationDate",
  patientCoveragePrimaryPolicyHolderSameAsPatient: "patientCoveragePrimaryPolicyHolderSameAsPatient",
  patientCoveragePrimaryPolicyholderName: "patientCoveragePrimaryPolicyholderName",
  patientCoveragePrimaryPolicyholderRelationship: "patientCoveragePrimaryPolicyholderRelationship",

  patientCoverageSecondaryType: "patientCoverageSecondaryType",
  patientCoverageSecondaryGroupId: "patientCoverageSecondaryGroupId",
  patientCoverageSecondaryMemberId: "patientCoverageSecondaryMemberId",
  patientCoverageSecondaryName: "patientCoverageSecondaryName",
  patientCoverageSecondaryPhone: "patientCoverageSecondaryPhone",
  patientDiagnoses: "patientDiagnoses",

  matchedPhysicianId: "matchedPhysicianId",
  matchedPhysicianFirstName: "matchedPhysicianFirstName",
  matchedPhysicianLastName: "matchedPhysicianLastName",
  matchedPhysicianNpi: "matchedPhysicianNpi",
  matchedPhysicianFacility: "matchedPhysicianFacility",
  matchedPhysicianAddress: "matchedPhysicianAddress",
  matchedPhysicianCity: "matchedPhysicianCity",
  matchedPhysicianState: "matchedPhysicianState",
  matchedPhysicianZip: "matchedPhysicianZip",
  matchedPhysicianPhone: "matchedPhysicianPhone",
  matchedPhysicianStateLicense: "matchedPhysicianStateLicense",
  matchedPhysicianDea: "matchedPhysicianDea",
  matchedPhysicianTaxId: "matchedPhysicianTaxId",

  facilityId: "facilityId",
  providerFacility: "providerFacility",
  facilityAddress: "facilityAddress",
  facilityCity: "facilityCity",
  facilityState: "facilityState",
  facilityZip: "facilityZip",
  facilityContactPhone: "facilityContactPhone",
  facilityContactEmail: "facilityContactEmail",
  facilityNpi: "facilityNpi",
  facilityDea: "facilityDea",
  facilityContactFax: "facilityContactFax",
  facilityContactName: "facilityContactName",
  facilityEmail: "facilityEmail",
  facilityName: "facilityName",
  facilityPhone: "facilityPhone",
  facilityFax: "facilityFax",
  facilityOfficeContactName: "facilityOfficeContactName",
  facilityPreferredMethodOfContact: "facilityPreferredMethodOfContact",
  facilityCollaboratingPhysician: "facilityCollaboratingPhysician",
  matchedPhysician: "matchedPhysician",
  matchedPhysicianPtan: "matchedPhysicianPtan",
  matchedPhysicianSpeciality: "matchedPhysicianSpeciality",
  patientBestTimetoCall: "patientBestTimetoCall",
  patientHasCaregiver: "patientHasCaregiver",
  patientOkToLeaveDetailedMessage: "patientOkToLeaveDetailedMessage",
  shipmentFacility: "shipmentFacility",
  siteOfService: "siteOfService",
  treatmentSiteName: "treatmentSiteName",

  legalRepresentative: "legalRepresentative",
  legalRepresentativeFirstName: "legalRepresentativeFirstName",
  legalRepresentativeLastName: "legalRepresentativeLastName",
  legalRepresentativeRelationship: "legalRepresentativeRelationship",
  legalRepresentativeEmail: "legalRepresentativeEmail",
  legalRepresentativePhone: "legalRepresentativePhone",

  patientCoveragePrimaryTypeName: "patientCoveragePrimaryTypeName",
  patientCoveragePrimaryRxMemberId: "patientCoveragePrimaryRxMemberId",
  patientCoveragePrimaryRxGroupID: "patientCoveragePrimaryRxGroupID",
  patientCoveragePrescriptionBin: "patientCoveragePrescriptionBin",
  patientCoveragePrescriptionPcn: "patientCoveragePrescriptionPcn",

  residentsInHousehold: "residentsInHousehold",
  householdIncome: "householdIncome",

  attachments: "attachments",

  drugName: "drugName",
  dispense: "dispense",
  cycle: "cycle",
  refill: "refill",
  monotherapyOrCombination: "monotherapyOrCombination",
  drugUsagePeriod: "drugUsagePeriod"
});

export const beUIFieldNamesMap = Object.freeze({
  "Patient Id": beFieldNames.patientId,
  "Patient First Name": beFieldNames.patientFirstName,
  "Patient Middle Name": beFieldNames.patientMiddleName,
  "Patient Last Name": beFieldNames.patientLastName,
  "Patient Date of Birth": beFieldNames.patientDob,
  "Patient Gender": beFieldNames.patientGender,
  "Patient Language": beFieldNames.patientLanguage,
  "Patient Address": beFieldNames.patientAddress,
  "Patient City": beFieldNames.patientCity,
  "Patient State": beFieldNames.patientState,
  "Patient Zip": beFieldNames.patientZip,
  "Patient Email": beFieldNames.patientEmail,
  "Patient Phone": beFieldNames.patientPhone,
  "Patient Phone Type": beFieldNames.patientPhoneType,

  "Caregiver First Name": beFieldNames.patientCaregiverName,
  "Caregiver Last Name": beFieldNames.patientCaregiverLastName,
  "Caregiver Email": beFieldNames.patientCaregiverEmail,
  "Caregiver Phone": beFieldNames.patientCaregiverPhone,
  "Caregiver Phone Type": beFieldNames.patientCaregiverPhoneType,

  "Primary Insurance Type": beFieldNames.patientCoveragePrimaryType,
  "Primary Insurance Group Id": beFieldNames.patientCoveragePrimaryGroupId,
  "Primary Insurance Member Id": beFieldNames.patientCoveragePrimaryMemberId,
  "Primary Insurance Name": beFieldNames.patientCoveragePrimaryName,
  "Primary Insurance Phone": beFieldNames.patientCoveragePrimaryPhone,
  "Primary Insurance Category": beFieldNames.patientCoveragePrimaryCategoryType,
  "Primary Insurance Active Date": beFieldNames.patientCoveragePrimaryActiveDate,
  "Primary Insurance Expiration Date": beFieldNames.patientCoveragePrimaryExpirationDate,
  "Primary Insurance Policy Holder Same As Patient": beFieldNames.patientCoveragePrimaryPolicyHolderSameAsPatient,
  "Primary Insurance Policy Holder Name": beFieldNames.patientCoveragePrimaryPolicyholderName,
  "Primary Insurance Policy Holder Relationship": beFieldNames.patientCoveragePrimaryPolicyholderRelationship,

  "Secondary Insurance Type": beFieldNames.patientCoverageSecondaryType,
  "Secondary Insurance Group Id": beFieldNames.patientCoverageSecondaryGroupId,
  "Secondary Insurance Member Id": beFieldNames.patientCoverageSecondaryMemberId,
  "Secondary Insurance Name": beFieldNames.patientCoverageSecondaryName,
  "Secondary Insurance Phone": beFieldNames.patientCoverageSecondaryPhone,
  "Patient Diagnoses": beFieldNames.patientDiagnoses,

  "Physician Id": beFieldNames.matchedPhysicianId,
  "Physician First Name": beFieldNames.matchedPhysicianFirstName,
  "Physician Last Name": beFieldNames.matchedPhysicianLastName,
  "Physician Npi": beFieldNames.matchedPhysicianNpi,
  "Physician Facility": beFieldNames.matchedPhysicianFacility,
  "Physician Address": beFieldNames.matchedPhysicianAddress,
  "Physician City": beFieldNames.matchedPhysicianCity,
  "Physician State": beFieldNames.matchedPhysicianState,
  "Physician Zip": beFieldNames.matchedPhysicianZip,
  "Physician Phone": beFieldNames.matchedPhysicianPhone,
  "Physician State License": beFieldNames.matchedPhysicianStateLicense,
  "Physician Dea": beFieldNames.matchedPhysicianDea,
  "Physician Tax Id": beFieldNames.matchedPhysicianTaxId,

  "Facility Id": beFieldNames.facilityId,
  "Facility Name": beFieldNames.providerFacility,
  "Facility Address": beFieldNames.facilityAddress,
  "Facility City": beFieldNames.facilityCity,
  "Facility State": beFieldNames.facilityState,
  "Facility Zip": beFieldNames.facilityZip,
  "Facility Contact Phone": beFieldNames.facilityContactPhone,
  "Facility Contact Email": beFieldNames.facilityContactEmail,
  "Facility Npi": beFieldNames.facilityNpi,
  "Facility Dea": beFieldNames.facilityDea,
  "Facility Contact Fax": beFieldNames.facilityContactFax,
  "Facility Contact Name": beFieldNames.facilityContactName,
  ...beFieldNames
});

export const reversedBeUIFieldNamesMap = Object.entries(beUIFieldNamesMap).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

export const feBEfieldNamesMap = Object.freeze({
  "patient.id": beFieldNames.patientId,
  "patient.firstName": beFieldNames.patientFirstName,
  "patient.middleName": beFieldNames.patientMiddleName,
  "patient.lastName": beFieldNames.patientLastName,
  "patient.dob": beFieldNames.patientDob,
  "patient.gender": beFieldNames.patientGender,
  "patient.primaryLanguage": beFieldNames.patientLanguage,
  "patient.address": beFieldNames.patientAddress,
  "patient.city": beFieldNames.patientCity,
  "patient.state": beFieldNames.patientState,
  "patient.zip": beFieldNames.patientZip,
  "patient.email": beFieldNames.patientEmail,
  "patient.phone": beFieldNames.patientPhone,
  "patient.phoneType": beFieldNames.patientPhoneType,

  "patient.caregiver.firstName": beFieldNames.patientCaregiverName,
  "patient.caregiver.lastName": beFieldNames.patientCaregiverLastName,
  "patient.caregiver.email": beFieldNames.patientCaregiverEmail,
  "patient.caregiver.phone": beFieldNames.patientCaregiverPhone,
  "patient.caregiver.phoneType": beFieldNames.patientCaregiverPhoneType,

  "insurance.primary.type": beFieldNames.patientCoveragePrimaryType,
  "insurance.medical.type": beFieldNames.patientCoveragePrimaryType,
  "insurance.primary.group": beFieldNames.patientCoveragePrimaryGroupId,
  "insurance.medical.group": beFieldNames.patientCoveragePrimaryGroupId,
  "insurance.primary.member": beFieldNames.patientCoveragePrimaryMemberId,
  "insurance.medical.member": beFieldNames.patientCoveragePrimaryMemberId,
  "insurance.primary.name": beFieldNames.patientCoveragePrimaryName,
  "insurance.medical.name": beFieldNames.patientCoveragePrimaryName,
  "insurance.primary.phone": beFieldNames.patientCoveragePrimaryPhone,
  "insurance.medical.phone": beFieldNames.patientCoveragePrimaryPhone,
  "insurance.primary.insuranceEffectiveDate": beFieldNames.patientCoveragePrimaryActiveDate,
  "insurance.medical.insuranceEffectiveDate": beFieldNames.patientCoveragePrimaryActiveDate,
  "insurance.primary.policyholderSameAsPatient": beFieldNames.patientCoveragePrimaryPolicyHolderSameAsPatient,
  "insurance.medical.policyholderSameAsPatient": beFieldNames.patientCoveragePrimaryPolicyHolderSameAsPatient,
  "insurance.primary.policyholderName": beFieldNames.patientCoveragePrimaryPolicyholderName,
  "insurance.medical.policyholderName": beFieldNames.patientCoveragePrimaryPolicyholderName,
  "insurance.primary.policyholderRelationship": beFieldNames.patientCoveragePrimaryPolicyholderRelationship,
  "insurance.medical.policyholderRelationship": beFieldNames.patientCoveragePrimaryPolicyholderRelationship,

  "insurance.secondary.type": beFieldNames.patientCoverageSecondaryType,
  "insurance.secondary.group": beFieldNames.patientCoverageSecondaryGroupId,
  "insurance.secondary.member": beFieldNames.patientCoverageSecondaryMemberId,
  "insurance.secondary.name": beFieldNames.patientCoverageSecondaryName,
  "insurance.secondary.phone": beFieldNames.patientCoverageSecondaryPhone,

  "provider.id": beFieldNames.matchedPhysicianId,
  "provider.firstName": beFieldNames.matchedPhysicianFirstName,
  "provider.LastName": beFieldNames.matchedPhysicianLastName,
  "provider.npi": beFieldNames.matchedPhysicianNpi,
  "provider.practiceName": beFieldNames.matchedPhysicianFacility,
  "provider.address": beFieldNames.matchedPhysicianAddress,
  "provider.city": beFieldNames.matchedPhysicianCity,
  "provider.state": beFieldNames.matchedPhysicianState,
  "provider.zip": beFieldNames.matchedPhysicianZip,
  "provider.phone": beFieldNames.matchedPhysicianPhone,
  "provider.stateLicense": beFieldNames.matchedPhysicianStateLicense,
  "provider.dea": beFieldNames.matchedPhysicianDea,
  "provider.taxId": beFieldNames.matchedPhysicianTaxId,

  "facility.id": beFieldNames.facilityId,
  "facility.name": beFieldNames.providerFacility,
  "facility Address": beFieldNames.facilityAddress,
  "facility.city": beFieldNames.facilityCity,
  "facility.state": beFieldNames.facilityState,
  "facility.zip": beFieldNames.facilityZip,
  "facility.phone": beFieldNames.facilityContactPhone,
  "facility.email": beFieldNames.facilityContactEmail,
  "facility.npi": beFieldNames.facilityNpi,
  "facility.dea": beFieldNames.facilityDea,
  "facility.fax": beFieldNames.facilityContactFax,
  "facility.contact.name": beFieldNames.facilityContactName
});
